export default "__VITE_ASSET__hHYwiuPm__"